import { Dropdown } from 'react-bootstrap';
import * as React from 'react';
import { Action } from 'moduleBase/modules/menu-balance/components/Action';
import { MenuItemList } from 'moduleBase/modules/menu-balance/components/MenuItemList';
import { Wait } from 'moduleBase/modules/menu-balance/components/Wait';
import { Frozen } from 'moduleBase/modules/menu-balance/components/Frozen';

const DropdownMenu = () => (
  <Dropdown.Menu
    className="dropdown-flat-menu dropdown-flat-menu_center"
  >
    <Action />
    <MenuItemList />
    <Wait />
    <Frozen />
  </Dropdown.Menu>
);

export { DropdownMenu };
